import { SagaIterator } from 'redux-saga';
import { CARBON_INTENSITY_RESET } from 'src/modules/carbon-intensity/actions/CarbonIntensityActions';
import { logDebug } from 'src/sagas/utils/logging';
import { call, put } from 'typed-redux-saga';

export function* resetCarbonIntensity(): SagaIterator<void> {
  yield* call(logDebug, 'Resetting carbon intensity data...');
  yield* put(CARBON_INTENSITY_RESET.trigger());
  yield* call(logDebug, 'Resetting carbon intensity data... done');
}
